import { useSelector } from 'react-redux';
import type { RootState } from '../redux/store';
import { isWalletAddressCollection } from '../utils/collectionMode';

/**
 * Uses `state.program.program` (detail payload) + `state.program.processors`.
 * Ensure `fetchProgramWithId` has run for the current program (ProgramContext, TenantPage, VpaPage, etc.).
 */
export function useCollectionMode(): { isWalletAddressCollection: boolean } {
  const processors = useSelector((s: RootState) => s.program.processors);
  const program = useSelector((s: RootState) => s.program.program);

  return {
    isWalletAddressCollection: isWalletAddressCollection(program, processors),
  };
}
